import ToppingsPicker, { renderToppingExtraPriceText } from './ToppingsPicker';

export default ToppingsPicker;
export { renderToppingExtraPriceText };
